import * as React from "react";
const SvgFiRrPodiumStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-podium-star_svg__a)">
      <path
        fill="#062147"
        d="M23 10H4V7c0-1.654 1.346-3 3-3h.172A3 3 0 0 0 10 6h3c1.654 0 3-1.346 3-3s-1.346-3-3-3h-3a3 3 0 0 0-2.828 2H7C4.243 2 2 4.243 2 7v3H1a1 1 0 1 0 0 2h1.153l1.304 7.821A4.984 4.984 0 0 0 8.389 24h7.223a4.985 4.985 0 0 0 4.932-4.179L21.848 12h1.153A1 1 0 1 0 23 10M10 2h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2m8.57 17.493A2.99 2.99 0 0 1 15.611 22H8.388a2.99 2.99 0 0 1-2.959-2.507L4.18 12h15.639zM8.043 15.876a.79.79 0 0 1 .77-.558h1.853l.563-1.756A.79.79 0 0 1 12 13c.364 0 .66.215.771.562l.563 1.756h1.853a.79.79 0 0 1 .77.558.79.79 0 0 1-.292.905l-1.507 1.101.573 1.771a.79.79 0 0 1-.297.906.79.79 0 0 1-.953-.005L12 19.465l-1.481 1.089a.8.8 0 0 1-.953.005.79.79 0 0 1-.297-.906l.572-1.771-1.506-1.101a.79.79 0 0 1-.292-.905"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-podium-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPodiumStar;
